import styles from './styles.module.scss';

import React, { HTMLProps } from 'react';
import ReactModal from 'react-modal';
import cx from 'clsx';

export const Spinner: React.FC<HTMLProps<HTMLDivElement>> = ({ className, ...props }) => (
  <div
    className={cx(styles.wrapper, className)}
    title="Loading"
    {...props}
  />
);

export const OverlaySpinner: React.FC<HTMLProps<HTMLDivElement>> = props => (
  <ReactModal
    overlayClassName={styles.overlay}
    bodyOpenClassName={styles.noScroll}
    shouldCloseOnEsc={false}
    shouldCloseOnOverlayClick={false}
    isOpen={true}
    className={styles.modal}
  >
    <Spinner {...props} />
  </ReactModal>
);
